export default {"src":"/_next/static/media/google.49e831bf.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};